
import * as Cookies from "js-cookie";
//import Cookies from "js-cookie";
window.Cookies = Cookies;

export default class {

    constructor() {
        this.container = document.querySelector('.ncookie');

        // Is the element present on the current page
        if (! this.container) {
            return;
        }
        //Set domain
        this.domain = 'www.redan.dk';

        this.cookieName = 'cookies-acceptance';
        this.cookieAnalytics = 'cookies-analytics';
        this.cookieMarketing = 'cookies-marketing';
        this.noCookieAnalytics = 'cookies-analytics-off';
        this.noCookieMarketing = 'cookies-marketing-off';
        this.acceptButton = document.getElementById('cookie-accept');
        this.expandButton = document.getElementById('cookie-expand');
        this.checkboxes = document.querySelector('.ncookie__checkboxes');
        this.btnIcon = document.querySelector('.ncookie__btn-icon');
        this.acceptAllText = document.getElementById('accept-all');
        this.acceptSelectedText = document.getElementById('accept-selected');
        this.expanded = false;

        //Check if analytics or marketing cookies already exist
        this.cookieValueCheck();

        // on close store the cookie and hide it
        this.acceptButton.addEventListener('click', () => {

            this.cookieValue()
            Cookies.set(this.cookieName, 'true', {path: '/', domain: this.domain, expires: 365/2 });

            if (this.container.classList.contains('show')) {
                this.container.classList.remove('show');
            }

            window.dispatchEvent(new Event('storage'));

            window.location.reload();

        });

        this.expandButton.addEventListener('click', () => {
            this.expanded = ! this.expanded;
            this.checkboxes.classList.toggle('ncookie__checkboxes--hidden');
            this.btnIcon.classList.toggle('ncookie__btn-icon--transformed');

            this.acceptAllText.classList.toggle('hide-all');
            this.acceptSelectedText.classList.toggle('hide-all');
        });

        // if we dont have the cookie, show it
        if (!Cookies.get(this.cookieName) ) {
            this.container.classList.add('show');
        } else if (!Cookies.get(this.noCookieAnalytics) && !Cookies.get(this.cookieAnalytics)) {
            this.container.classList.add('show');
        } else if (!Cookies.get(this.noCookieMarketing) && !Cookies.get(this.cookieMarketing)) {
            this.container.classList.add('show');
        } else {
            // we have the cookie
            return;
        }


    }

    /**
     * We set analytics and marketing cookies
     */
    cookieValue() {
        let analytics = document.getElementById('checkbox-analytics');
        let marketing = document.getElementById('checkbox-marketing');
        //Set marketing cookie
        if (marketing.checked || ! this.expanded) {
            Cookies.remove("_fbp", {path: '/', domain: this.domain});
            Cookies.remove("UID", {path: '/', domain: this.domain});
            Cookies.set(this.cookieMarketing, 'true', {path: '/', domain: this.domain, expires: 365/2 });
            Cookies.remove(this.noCookieMarketing, {path: '/', domain: this.domain});
            //localStorage.setItem('tracking-marketing', 'true');
        } else {
            Cookies.remove("_fbp", {path: '/', domain: this.domain});
            Cookies.remove("UID", {path: '/', domain: this.domain});
            Cookies.set(this.noCookieMarketing, 'true', {path: '/', domain: this.domain, expires: 30 });
            Cookies.remove(this.cookieMarketing, {path: '/', domain: this.domain});
        }
        //Set analytics cookie
        if (analytics.checked || ! this.expanded) {
            Cookies.remove("_ga", {path: '/', domain: this.domain});
            Cookies.remove("_gid", {path: '/', domain: this.domain});
            Cookies.remove("_ga_K2EMBNBBQ4", {path: '/', domain: this.domain});
            Cookies.remove("_gcl_au", {path: '/', domain: this.domain});
            Cookies.set(this.cookieAnalytics, 'true', {path: '/', domain: this.domain, expires: 365/2 });
            Cookies.remove(this.noCookieAnalytics, {path: '/', domain: this.domain});
            //localStorage.setItem('tracking-analytics', 'true');
        } else {
            Cookies.remove("_ga", {path: '/', domain: this.domain});
            Cookies.remove("_gid", {path: '/', domain: this.domain});
            Cookies.remove("_ga_K2EMBNBBQ4", {path: '/', domain: this.domain});
            Cookies.remove("_gcl_au", {path: '/', domain: this.domain});
            Cookies.set(this.noCookieAnalytics, 'true', {path: '/', domain: this.domain, expires: 30 });
            Cookies.remove(this.cookieAnalytics, {path: '/', domain: this.domain});
        }

    }

    cookieValueCheck() {
        let analytics = document.getElementById('checkbox-analytics');
        let marketing = document.getElementById('checkbox-marketing');
        //Set checked if marketing cookie exist
        if(Cookies.get(this.cookieMarketing)) {
            marketing.checked = true;
        } else {
            Cookies.remove("_fbp", {path: '/', domain: this.domain});
            marketing.checked = false;
        }
        //Set checked if analytics cookie exist
        if(Cookies.get(this.cookieAnalytics)) {
            analytics.checked = true;
        } else {
            Cookies.remove("_ga", {path: '/', domain: this.domain});
            Cookies.remove("_gid", {path: '/', domain: this.domain});
            Cookies.remove("_ga_K2EMBNBBQ4", {path: '/', domain: this.domain});
            Cookies.remove("_gcl_au", {path: '/', domain: this.domain});
            analytics.checked = false;
        }
    }
}
